import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  locales: ["en"],
  defaultLocale: "en",
  // 'always' para static export - URLs siempre con prefijo de locale /en/...
  localePrefix: "always",
});

// Export helpers para navigation
export type Locale = typeof routing.locales[number];
